export default __webpack_public_path__ + "static/cert-2-img-d527fdeb0018df94889612d67f73aa10.png";